import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { centerDialogAtom, INITIAL_CENTER_DIALOG_STATE } from '@lib/states/dialogs/centerDialogAtom';
import { useSetJotaiAtom } from '@states/jotai/hooks';
import type { TCenterDialogState } from '@lib/states/dialogs/centerDialogAtom';
import type { ReactNode } from 'react';
export type TUseCenterDialogReturn = {
  open: (children: ReactNode, args?: TCenterDialogState) => void;
  close: () => void;
};
export const useCenterDialog = () => {
  const $ = _c(7);
  const setDialogState = useSetJotaiAtom(centerDialogAtom);
  let t0;
  if ($[0] !== setDialogState) {
    t0 = (children, args) => {
      setDialogState({
        isOpen: true,
        children,
        size: args?.size ?? "sm",
        shouldCloseOnBlur: args?.shouldCloseOnBlur
      });
    };
    $[0] = setDialogState;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const open = t0;
  let t1;
  if ($[2] !== setDialogState) {
    t1 = () => {
      setDialogState(INITIAL_CENTER_DIALOG_STATE);
    };
    $[2] = setDialogState;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const close = t1;
  let t2;
  if ($[4] !== close || $[5] !== open) {
    t2 = {
      open,
      close
    };
    $[4] = close;
    $[5] = open;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};